<template>
  <Dialog type="history" :show="$bus.history.show" :title="$bus.transify['LUCKY_HISTORY']">
    <template v-slot:dialog-content>
      <div class="history-content">
        <ul class="history-list" v-if="$bus.history.data.length" ref="historyList">
          <template v-for="history in $bus.history.data">
            <ItemLine class="history-list-item" :key="history.created" :history="history"/>
          </template>
        </ul>
      </div>
    </template>
  </Dialog>
</template>

<script>
import Dialog from '@/components/common/Dialog.vue'
import ItemLine from '@/components/history/item.vue'
export default {
  components: {
    Dialog,
    ItemLine
  },
  watch: {
    '$bus.history.show': {
      handler (current) {
        if (!current) {
          this.$refs.historyList.scrollTop = 0
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.history-content {
  width: 100%;
  .history-list {
    width: 95%;
    overflow: hidden;
    overflow-y: auto;
    margin: 0 auto;
    @include px2res(padding, 0, 20);
    @include px2res(height, 356);
    .history-list-item {
      border-bottom: 2px solid rgba(61, 83, 120, .4);
    }
    .history-list-item:last-child {
      border-bottom: none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/history/index.vue